import {FreespinTrainSymbol} from "../../../symbols/freespin/train/FreespinTrainSymbol";
import {FireInTheHole2} from "../../../FireInTheHole2";
import {FITH2SoundManager} from "../../../sound/FITH2SoundManager";
import {APISetting} from "@nolimit/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap";
import {FreespinTrainView} from "./FreespinTrainView";
import {IFsSymbolData} from "../../../symbols/freespin/FreespinSymbol";

export class TopTrainView extends FreespinTrainView {
    constructor(id: number) {
        super(id);
        this.name = "topTrain";
        this._reelId = id;
    }

    public initReel(symbols: IFsSymbolData[]): void {
        for (let i: number = 0; i < symbols.length; i++) {
            const symbol: FreespinTrainSymbol = this.createSymbol(symbols[i]);
            this._allSymbols.push(symbol);
        }
    }

    public show(reelData: IFsSymbolData[], isFromIntro: boolean): void {
        this._container.position.x = 58;
        this._allSymbols.forEach((symbol: FreespinTrainSymbol, i: number) => {
            symbol.position.set(100 * i, 0);
            if (isFromIntro) {
                symbol.show(reelData[i]);
            }
            this._container.addChild(symbol);
        });
    }

    public stop(reelData: IFsSymbolData[], duration: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(gsap.to(this._container, 0, {x: 1058}));
        tl.add([
            () => {
                FITH2SoundManager.playSound("fsWagonIn");
            },
            gsap.to(this._container, duration, {x: 58})
        ]);
        this._allSymbols.forEach((symbol: FreespinTrainSymbol, i: number) => {
            symbol.stop(reelData[i]);
            tl.add(() => {
                FITH2SoundManager.playHighValueFSSymbolEnter(reelData[i].symName);
            }, i * 0.1);
            tl.add(symbol.stopped(), duration);
        });
        return tl;
    }

    public spin(delay: number, hasAnticipation: boolean): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            //FITH2SoundManager.playReelIn();
        }, 0);

        tl.add(() => {
            FITH2SoundManager.playSound("fsWagonOut");
            this._allSymbols.forEach((symbol: FreespinTrainSymbol) => {
                symbol.spin();
            });
        }, 0);

        tl.add(gsap.to(this._container, 0, {x: 58}), 0);
        tl.add(gsap.to(this._container, 1, {x: -1058}));
        return tl;
    }

    get isFastSpin(): boolean {
        const fastSpin: boolean = FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN, false);
        return fastSpin;
    }

    public getSymbol(position: number): FreespinTrainSymbol {
        if (position > (this._allSymbols.length - 1)) {
            debugger;
        }
        return this._allSymbols[position];
    }
}